export const ServerError = () => {
  return (
    <div>
      <h1>500 - Server Error</h1>
    </div>
  );
};
